import { render, staticRenderFns } from "./coustomerDialog.vue?vue&type=template&id=12e09a50&scoped=true"
import script from "./coustomerDialog.vue?vue&type=script&lang=js"
export * from "./coustomerDialog.vue?vue&type=script&lang=js"
import style0 from "./coustomerDialog.vue?vue&type=style&index=0&id=12e09a50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e09a50",
  null
  
)

export default component.exports